var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from "react";
import { CollapseContext } from "./Collapse.context";
import { Button } from "../../components";
var CollapseCloseButton = forwardRef(function (_a, ref) {
    var className = _a.className, style = _a.style, otherProps = __rest(_a, ["className", "style"]);
    var contextValue = useContext(CollapseContext);
    if (!contextValue) {
        console.warn("CollapseContext provider is needed");
        return null;
    }
    var id = contextValue.id, closeCollapse = contextValue.closeCollapse;
    var classButton = "fr-btn--close";
    if (className) {
        classButton += " ".concat(className);
    }
    return (React.createElement(Button, __assign({}, otherProps, { className: classButton, style: style, ref: ref, "aria-controls": id, onClick: closeCollapse, role: "button", title: "Fermer" }), "Fermer"));
});
export default CollapseCloseButton;
